// extracted by mini-css-extract-plugin
export default {"repositionModeButtons":"ffgfrj","buttonsBox":"aELYGw","truncateText":"SPVSYZ","cancelButton":"mtITEX"};